import { render, staticRenderFns } from "./CreatePacket.vue?vue&type=template&id=bc3b60c4"
import script from "./CreatePacket.vue?vue&type=script&lang=js"
export * from "./CreatePacket.vue?vue&type=script&lang=js"
import style0 from "./CreatePacket.vue?vue&type=style&index=0&id=bc3b60c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports